import React from 'react';
import ContentLoader from 'react-content-loader'
import settings from '../../../settings.json'

function ShopItemPs(props) {
    return (
        <>
        <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <ContentLoader
                height={450}
                speed={settings.placehoder.speed}
                style={{width:"100%"}}
                backgroundColor={settings.placehoder.background}
                foregroundColor={settings.placehoder.foreground}>
                <rect x="0" y="10" rx="0" ry="0" height="450" style={{width:"100%"}} />
            </ContentLoader>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12" style={{textAlign:"left"}}>
            <div>
            <ContentLoader
                height={20}
                speed={settings.placehoder.speed}
                style={{width:"100%"}}
                backgroundColor={settings.placehoder.background}
                foregroundColor={settings.placehoder.foreground}>
                <rect x="0" y="10" rx="0" ry="0" height="15" style={{width:"70%"}} />
            </ContentLoader>
            </div>
            <div>
            <ContentLoader
                height={40}
                speed={settings.placehoder.speed}
                style={{width:"100%"}}
                backgroundColor={settings.placehoder.background}
                foregroundColor={settings.placehoder.foreground}>
                <rect x="0" y="10" rx="0" ry="0" height="15" style={{width:"50%"}} />
                <rect x="0" y="30" rx="0" ry="0" height="15" style={{width:"60%"}} />
            </ContentLoader>
            </div>
            <div>
            <ContentLoader
                height={20}
                speed={settings.placehoder.speed}
                style={{width:"100%"}}
                backgroundColor={settings.placehoder.background}
                foregroundColor={settings.placehoder.foreground}>
                <rect x="0" y="10" rx="0" ry="0" height="15" style={{width:"30%"}} />
            </ContentLoader>
            </div>
            <div>
                <ContentLoader
                height={40}
                speed={settings.placehoder.speed}
                style={{width:"100%"}}
                backgroundColor={settings.placehoder.background}
                foregroundColor={settings.placehoder.foreground}>
                <rect x="0" y="10" rx="0" ry="0" height="15" style={{width:"50%"}} />
            </ContentLoader>
            <ContentLoader
                height={150}
                speed={settings.placehoder.speed}
                style={{width:"100%"}}
                backgroundColor={settings.placehoder.background}
                foregroundColor={settings.placehoder.foreground}>
                <rect x="0" y="10" rx="0" ry="0" height="15" style={{width:"70%"}} />
                <rect x="0" y="30" rx="0" ry="0" height="15" style={{width:"60%"}} />
            </ContentLoader>
            <ContentLoader
                height={150}
                speed={settings.placehoder.speed}
                style={{width:"100%"}}
                backgroundColor={settings.placehoder.background}
                foregroundColor={settings.placehoder.foreground}>
                <rect x="30%" y="0" rx="0" ry="0" height="40" style={{width:"30%",margin:"0 auto"}} />
            </ContentLoader>
            </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <ContentLoader
            height={500}
            speed={settings.placehoder.speed}
            style={{width:"100%"}}
            backgroundColor={settings.placehoder.background}
            foregroundColor={settings.placehoder.foreground}>
            <rect x="0" y="10" rx="0" ry="0" height="15" style={{width:"85%"}} />
            <rect x="0" y="35" rx="0" ry="0" height="15" style={{width:"65%"}} />
            <rect x="0" y="60" rx="0" ry="0" height="15" style={{width:"90%"}} />
            <rect x="0" y="85" rx="0" ry="0" height="15" style={{width:"60%"}} />
        </ContentLoader>
        </div>
        </div>
    </>
    );
}

export default ShopItemPs;